'use client'

import { cn } from '@/utils/styles/cn'

type IPillBadgeVariant = 'beta' | 'muted'

interface IPillBadgeProps {
    label: string
    variant?: IPillBadgeVariant
    /** Set false to render the label without the leading status dot. */
    withDot?: boolean
    className?: string
}

const variantClasses: Record<IPillBadgeVariant, string> = {
    beta: 'border-orange-200/90 bg-linear-to-br from-orange-50 via-amber-50/90 to-orange-100/80 text-orange-800/95 shadow-[0_1px_3px_rgba(249,115,22,0.2),inset_0_1px_0_rgba(255,255,255,0.6)]',
    muted: 'border-stone-200/90 bg-linear-to-br from-stone-50 via-stone-50/90 to-stone-100/80 text-stone-600 shadow-[0_1px_2px_rgba(0,0,0,0.06),inset_0_1px_0_rgba(255,255,255,0.8)]',
}

const dotClasses: Record<IPillBadgeVariant, string> = {
    beta: 'bg-[#FF631B]/90 shadow-[0_0_6px_rgba(255,99,27,0.45)]',
    muted: 'bg-stone-400 shadow-[0_0_2px_rgba(0,0,0,0.15)]',
}

export function PillBadge({ label, variant = 'muted', withDot = true, className }: IPillBadgeProps) {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[9px] font-semibold uppercase tracking-widest select-none whitespace-nowrap',
                variantClasses[variant],
                className
            )}
        >
            {withDot && <span className={cn('size-1 rounded-full', dotClasses[variant])} aria-hidden />}
            {label}
        </span>
    )
}
